/**
 * @author: lv.chen
 * @date: 2025/4/27
 * @desc: 可删除的标签
 */
import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';
import type { IGeneralTagFormatter } from '@gp/components/GeneralTag';

import './index.scss';

interface IGeneralDeletableTagProps extends IBaseProps {
  isError?: boolean;
  text?: string;
  formatter?: IGeneralTagFormatter;
  onDelete?: (text?: string) => void;
}

const GeneralDeletableTag: React.FC<IGeneralDeletableTagProps> = (props) => {
  const { style, className, isError = false, text, formatter, onDelete } = props;

  const formattedText = formatter?.(text) ?? text;

  return (
    <div
      style={style}
      className={classnames('dbg-general-deletable-tag', className, {
        'dbg-general-deletable-tag--error': isError,
      })}
    >
      <span className="dbg-general-deletable-tag__tag-text">{formattedText}</span>
      <a
        className="tea-icon tea-icon-dismiss dbg-general-deletable-tag__tag-close-icon"
        role="img"
        aria-label="dismiss"
        onClick={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
          onDelete?.(text);
        }}
      />
    </div>
  );
};

export default GeneralDeletableTag;
